import { render, staticRenderFns } from "@/clickbuy/purchase/views/purchase-form/purchase-form.pug?vue&type=template&id=7bee8c08&scoped=true&lang=pug&external"
import script from "./purchase-form.view.vue?vue&type=script&lang=ts"
export * from "./purchase-form.view.vue?vue&type=script&lang=ts"
import style0 from "@/clickbuy/purchase/views/purchase-form/purchase-form.scss?vue&type=style&index=0&id=7bee8c08&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bee8c08",
  null
  
)

export default component.exports